import { defineStore } from 'pinia';
import { useStoreSsPlayer } from '../softswiss/player';
import { useStoreTransactionHistory } from '../softswiss/transactionHistory';
import { useStoreCurrencyMenu } from '../strapi/currencyMenu';
import { useStoreRoot } from './root';
import type { IGtmPush } from '~/types/gtm';

export const useStoreGtm = defineStore('abstractGtm', {
  state: () => ({
    enabled: true,
  }),
  actions: {
    push(data: IGtmPush) {
      if (this.enabled) {
        const extendedData = { ...data };
        const storeCurrencyMenu = useStoreCurrencyMenu();
        const storeRoot = useStoreRoot();
        if (data.with_flow_name) {
          const isCryptoFlow = storeCurrencyMenu.isCryptoCurency(storeRoot.userCurrency);
          extendedData.flow_name = isCryptoFlow ? 'crypto' : 'fiat';
          delete extendedData.with_flow_name;
        }
        return useGtm()?.push(extendedData);
      }
    },
    updateUserParams() {
      const storeSsPlayer = useStoreSsPlayer();
      const storeRoot = useStoreRoot();
      const storeTransactionHistory = useStoreTransactionHistory();
      const deposits = storeTransactionHistory.payments.filter((item) => item.action === 'deposit');
      if (this.enabled) {
        let userType = 'new';
        if (storeSsPlayer.isPlayerAuthorised) {
          if (!deposits.length) {
            userType = 'registered';
          } else if (deposits.length === 1) {
            userType = 'first_deposit';
          } else {
            userType = 'returned';
          }
        }
        return useGtm()?.push({
          user_id: storeSsPlayer.playerId,
          language: storeRoot.userLang,
          user_type: userType,
        });
      }
    },
    enable() {
      this.enabled = true;
      return useGtm()?.enable(true);
    },
  },
});
